export default __webpack_public_path__ + "static/media/PERL-BNB.0df1009c.svg";